module.exports = __webpack_public_path__ + "img/im.bed05fde.svg";